<template>
  <button
    :class="{
      'primary-button': classType === 'primary',
      'secondary-button': classType === 'secondary',
      [customClass]: customClass
    }"
    :style="{ color: textColor }"
    :type="type"
    :disabled="disabledButton"
    @click="onClick($event)"
  >
    <slot />
    <spinner
      v-if="loading"
      line-fg-color="#78FAAE"
    />
    <template v-else>
      {{ text }}
    </template>
  </button>
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from 'vue-simple-spinner';

export default {
  props: {
    text: {
      default: '',
      type: String,
    },
    textColor: {
      default: '',
      type: String,
    },
    classType: {
      default: 'primary',
      type: String,
    },
    customClass: {
      default: '',
      type: String,
    },
    type: {
      default: 'button',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    Spinner,
  },
  computed: {
    ...mapGetters({
      buttonColor: 'brand/getPrimaryColor',
    }),
    disabledButton() {
      if (this.loading) {
        return true;
      }
      return this.disabled;
    },
  },
  methods: {
    onClick() {
      this.$emit('buttonClick');
    },
  },
};
</script>
